var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "", "mb-5": "" } },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { staticClass: "text-center", attrs: { xs6: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "fixed-bottom-right",
                      attrs: {
                        slot: "activator",
                        color: "error",
                        disabled: _vm.configurations.length == 0,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearAllConfigurations()
                        },
                      },
                      slot: "activator",
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("message.Svuota")) + " "),
                      _c("v-icon", [_vm._v("delete_forever")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { wrap: "", "justify-center": "" } },
            [
              _c(
                "v-scale-transition",
                {
                  staticClass: "layout row wrap justify-center",
                  attrs: { group: "", "leave-absolute": "", tag: "div" },
                },
                [
                  _vm._l(_vm.parsedConfigurations, function (c, index) {
                    return [
                      _c("item-card", {
                        key: index,
                        attrs: { canDelete: true, canRestore: true, item: c },
                        on: {
                          delete: function ($event) {
                            return _vm.removeConfiguration(index)
                          },
                          restore: function ($event) {
                            _vm.restoreConfiguration(index)
                            _vm.profileOpen = false
                          },
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }